<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="changeStatusModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zmień status wybranych wierszy</h5>

            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="error" class="alert alert-danger" role="alert">
              {{ error }}
            </div>

			<div class="row">
			  <div class="col-md-3">
				<label for="project-select">Wybierz status:</label>
				<select id="project-select" class="form-select form-select-sm" v-model="newSelectedStatus">
				  <option v-for="status in statuses" :key="status.name" :value="status.name">
					{{ status.name }}
				  </option>
				</select>
			  </div>
			</div>

            <div class="table-responsive mt-5">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Nr poz.</th>
                  <th>Podzespół nr rysunku</th>
                  <th>Nr katalogowy</th>
                  <th>Model</th>
                  <th>Nazwa/Opis</th>
                  <th>Ilość do zamówienia</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in selectedRecords">
                  <td>{{ record.id }}</td>
                  <td>{{ record.subteam_drawing_no }}</td>
                  <td>{{ record.article?.catalog_number || '' }}</td>
                  <td>{{ record.article.model }}</td>
                  <td>{{ record.article.description }}</td>
                  <td>{{ record.quantity_required * record.numbering.quantity }}</td>
                  <td>{{ record.status }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>

            <form @submit.prevent="submitForm">
              <button type="submit" class="btn btn-primary">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {Modal} from "bootstrap";

let dropInstanceFilterUnits, delivererElem, multiSelectObj;

export default {
  props: {
    selectedRecords: Object,
    statuses: Object
  },

  data() {

    return {
      newSelectedStatus: null,
      error: null,
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
			  this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
  },

  methods: {
    updateSelectedStatus(event) {
      this.newSelectedStatus = event.target.value;
    },

    submitForm() {
      let record_ids = this.selectedRecords.map(item => ({id: item.id}));
      axios.post(route('requiredProjectItems.change-status', {
            records: record_ids,
            newStatus: this.newSelectedStatus
          }
      )).then(() => {
        this.$emit('added-success', 'Zmieniono status poprawnie');
        this.$emit('updated-article');
		this.$emit('clear-selection');
        this.hide();
      }).catch(error => {
        this.error = error.response.data
        console.log('error', error);
      });
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}

</script>
